var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill fill-sm fill-grey text-rothek p-10",staticStyle:{"text-wrap":"nowrap"}},[_vm._v(_vm._s(_vm.currentKey + 1)+" / "+_vm._s(_vm.questions.questions.length))])
}
var staticRenderFns = []

export { render, staticRenderFns }